<template>
  <el-row>
    <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' :span="4" v-loading="loadingAssignedApplications">
      <applications-lane
        :assignedApplications="assignedApplications"
        :assignedApps="assignedApps"
        @addUniversity='addUniversityEvent'>
      </applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
              <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal && !isPostExam" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication" :omotages='omotages'></titles>
                  <select-col-fac-dep
                    :applicationId="workingApplication.id"
                    :consideration= false :title="workingApplication.titles">
                  </select-col-fac-dep>
                </el-tab-pane>
                 <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                  v-if='workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"
                    :omotagesConsideration='omotagesConsideration'>
                  </title-consideration>
                  <select-col-fac-dep
                    :applicationId="workingApplication.id"
                    :consideration= true
                    :title="workingApplication.titles.titleConsideration">
                  </select-col-fac-dep>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :userComment="workingApplication.userComment"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :neededDocuments="workingApplication.neededDocuments"
                    :appId="workingApplication.id"
                    :role="role">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <special-proponent-judgment
                    @changedAssignedRole="changedAssignedRoleEvent"
                    :application='workingApplication'
                    :omotages='omotages'
                    :omotagesConsideration='omotagesConsideration'
                    :roleName='roleName'
                    :usersToAssign='usersToAssign'
                    :loadingRoleMembers='loadingRoleMembers'
                    :isReappraisal='isReappraisal'
                    :isPostExam="isPostExam">
                  </special-proponent-judgment>
                </el-tab-pane>
                <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal || isPostExam">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
        <manage-db :addUniversity='addUniversity' v-if='addUniversity'></manage-db>
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import SpecialProponentJudgment from './roleSpecific/SpecialProponentJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import UserAppInfo from './common/UserAppInfo'
import axios from 'axios'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import SearchUni from '@/components/common/SearchUni'
import SelectColFacDep from '@/components/common/SelectColFacDep'
import ManageDb from './roleSpecific/ManageDb'
import sharedMethods from '@/components/common/sharedMethods.js'
import RelevantApp from './common/RelevantApp'

export default {
  name: 'SpecialProponent',
  components: {
    ManageDb,
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    SpecialProponentJudgment,
    ApplicationsLane,
    UserAppInfo,
    ApplicationSearch,
    SearchUni,
    SelectColFacDep,
    RelevantApp
  },
  mixins: [sharedMethods],
  data () {
    return {
      addUniversity: false,
      assignedApps: {proponentW_President: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
        // proponentW_Board: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        proponentW_Prechecker: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        proponentW_Admin: [{ id: '3', surname: '', createdAt: '', degreeType: '' }],
        proponentW_ReappraisalBoard: [{ id: '4', surname: '', createdAt: '', degreeType: '' }]
      },
      role: 'proponent',
      activeName: 'sixth',
      notificationsDialogVisible: false,
      listAssignedApplications: [],
      viewApplication: {},
      myApplications: [],
      applicationView: false,
      omotages: '',
      omotagesConsideration: '',
      usersToAssign: [],
      loadingRoleMembers: false,
      roleName: 'τον Διοικητικό Έλεγχο' // process viewer is back
    }
  },
  methods: {
    addUniversityEvent () {
      this.addUniversity = !this.addUniversity
    },
    changedAssignedRoleEvent (role) {
      this.getRoles(role)
      // this.getRoles(this.workingApplication.applicationHistory.slice(-1)[0].judgment.assignedTo.role)
    },
    handleClick (tab, event) {
    },
    loadViewApplication (id) {
      axios.get(`${this.BASE_URL}/users/uid/applications/${id}`)
        .then((response) => {
          this.applicationView = true
          this.viewApplication = response.data.workingApplication
        }, (err) => {
          this.backendError(err)
        })
    },
    getAttachments () {
      let docType = 18
      let dispatchType = 'SET_PROPONENT_ATTACHMENTS'
      if (this.fromReappraisalBoard) {
        docType = 1016
        dispatchType = 'SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS'
      }
      return axios.get(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`
      ).then(response => {
        let attachments = response.data.data
        attachments = attachments.filter(a => a.file.name !== '' && a.file.type === docType)
        this.$store.dispatch(dispatchType, attachments)
      }).catch(err => {
        this.backendError(err)
        throw err
      })
    },
    getRoles (role) {
      let roleId
      switch (role) {
        case 'ProcessViewer':
          // roleId = 8
          this.usersToAssign = []
          // this.getRoleMembers(roleId)
          this.loadingRoleMembers = false
          this.roleName = 'τον Διοικητικό Έλεγχο'
          break
        case 'AcademicConsultant':
          roleId = 4
          this.usersToAssign = []
          this.getRoleMembers(roleId)
          // this.loadingRoleMembers = true
          this.roleName = 'τον Ακαδημαϊκό Σύμβουλο'
          break
        case 'ExecutiveBoardMember':
          this.usersToAssign = []
          this.loadingRoleMembers = false
          this.roleName = 'την Εκτελεστική Επιτροπή'
          break
      }
    },
    getRoleMembers (roleId) {
      this.usersToAssign = []
      this.loadingRoleMembers = true
      axios.get(
        `${this.BASE_URL}/roles/${roleId}`
      ).then((response) => {
        this.usersToAssign = response.data.data
        this.usersToAssign = this.usersToAssign.sort(this.compare)
      }, (err) => {
        this.backendError(err)
        this.loadingRoleMembers = false
      })
    },
    compare (a, b) {
      // Use toUpperCase() to ignore character casing
      const nameA = a.surname.toUpperCase()
      const nameB = b.surname.toUpperCase()

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    }
  },
  computed: {
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    isPostExam () {
      return this.workingApplication.applicationType === 'compensatory'
    },
    lastState () {
      return this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus
    },
    fromReappraisalBoard () {
      return ['proponentW_ReappraisalBoard'].includes(this.lastState)
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    ...mapState([
      'searchVisible',
      'searchUniVisible',
      'statsVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'attachedSimilarAct',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL'
    ]),
    ...mapGetters({ currentUser: 'currentUser' })
  },
  watch: {
    assignedApplications: function (newData, oldData) {
      this.listAssignedApplications = this.assignedApplications
    },
    workingApplication: function (newData, oldData) {
      if (!this.isReappraisal && !this.isPostExam) {
        this.activeName = 'second'
        this.omotages = ''
        const stat = this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus
        const titl = this.workingApplication.titles
        if (['proponentW_President', 'proponentW_Admin', 'proponentW_Board', 'proponentW_Prechecker'].includes(stat)) {
          if (titl.university.id !== null) {
            axios.get(
              `${this.BASE_URL}/equivalentInstitution/${titl.university.id}` +
              `/eqCollege/${titl.college.id}` +
              `/eqFaculty/${titl.faculty.id}` +
              `/eqDept/${titl.department.id}`
            ).then((response) => {
              this.omotages = response.data.data
            }, (err) => {
              this.backendError(err)
            })
          }
          if (titl.titleConsideration && titl.titleConsideration.university.id !== null) {
            this.omotagesConsideration = ''
            axios.get(
              `${this.BASE_URL}/equivalentInstitution/${titl.titleConsideration.university.id}` +
              `/eqCollege/${titl.titleConsideration.college.id}` +
              `/eqFaculty/${titl.titleConsideration.faculty.id}` +
              `/eqDept/${titl.titleConsideration.department.id}`
            ).then((response) => {
              this.omotagesConsideration = response.data.data
            }, (err) => {
              this.backendError(err)
            })
          }
        }
        // this.getAttachments()
        const rol = this.workingApplication.applicationHistory.slice(-1)[0].judgment.assignedTo.role
        if (rol !== null) {
          this.getRoles(rol)
        }
        // this.$store.dispatch('SET_SIMILAR_ACT_ATTACHED', [])
      }
      if (this.isReappraisal || this.isPostExam) {
        this.activeName = 'sixth'
      }
    }
  }
}
</script>
<style lang="scss">
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
div.el-transfer-panel {
  width: 350px
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
/*.el-input--small .el-input__inner {*/
  /*width: 150px*/
/*}*/
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpecialProponent.vue